import { render } from "./LiteIntegrationAssetLocationAssets.vue?vue&type=template&id=39f6e0b8"
import script from "./LiteIntegrationAssetLocationAssets.vue?vue&type=script&lang=js"
export * from "./LiteIntegrationAssetLocationAssets.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__